import { useDispatch, useSelector } from "react-redux";
import logoImg from "../../assets/images/logo/logo.png";
import moonImg from "../../assets/images/svgs/icons8-moon-64.png";
import sunImg from "../../assets/images/svgs/icons8-sun-50.png";
import { DASHBOARD_VERSION } from "../../constants/dashboardVersion";
import { logout } from "../../features/user/userSlice";
import { useTheme } from "../../providers/ThemeProvider";
import Button from "../button/Button";
import TextWrapper from "../textWrapper/TextWrapper";
import styles from "./header.module.css";

const Header = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const userName = useSelector((state) => state.user.userName);
  const dispatch = useDispatch();
  const { isDark, toggleTheme } = useTheme();

  const handleLogout = () => {
    dispatch(logout());
  };

  const themeToggleLabel = isDark
    ? "التبديل إلى الوضع الفاتح"
    : "التبديل إلى الوضع الداكن";

  return (
    <header className={styles.container}>
      <div className={styles.slotStart}>
        <div className={styles.versionBadge}>v{DASHBOARD_VERSION}</div>
      </div>

      <div className={styles.slotCenter}>
        {isLoggedIn && userName ? (
          <p className={styles.greeting} dir="rtl">
            <span className={styles.greetingHi}>اهلا،</span>
            <span className={styles.greetingName}>{userName}</span>
          </p>
        ) : null}
      </div>

      <div className={styles.slotEnd}>
        <div className={styles.logoContainer}>
          <img src={logoImg} alt="SC SPORT Logo" />
          {isLoggedIn && (
            <div className={styles.headerActions}>
              <button
                type="button"
                className={styles.themeToggle}
                onClick={toggleTheme}
                title={themeToggleLabel}
                aria-label={themeToggleLabel}
              >
                <img
                  src={isDark ? sunImg : moonImg}
                  alt=""
                  aria-hidden
                  className={styles.themeToggleIcon}
                />
              </button>
              <div className={styles.logoutWrapper}>
                <Button
                  variant="logoutVariant"
                  size="midSize"
                  functionallity={handleLogout}
                >
                  <TextWrapper textStyle={"textMid"}>تسجيل خروج</TextWrapper>
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
